import React, { useEffect, useRef, useState } from 'react';
import {
  Row,
  Col,
  Image,
  Table,
  Modal,
  Form,
  Button,
  InputGroup,
  Tab,
  Nav
} from 'react-bootstrap';
import EmptyRow from '../../components/emptyRow/EmptyRow';
import icTitle from '../../assets/images/ic-edit-modal.svg';
import ENGModalHeader from '../../components/modal/ENGModalHeader';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  GetSectorList,
  selectSectorList
} from '../../features/helpandassistance/SectorListSLice';
import Edit from '../../assets/images/ic-edit.svg';
import DeleteBox from '../../assets/images/ic-deletebox.svg';
import ModalDelete from '../../assets/images/delete-bin-line.svg';
import {
  GetAllCompany,
  selectAllCompany
} from '../../features/company/companyListSlice';
import { formatDate } from '../../constant/DateFormat';
import Pagination from '../../constant/pagination';
import '../../constant/pagination.css';
import { GetInsertCompany } from '../../features/company/insertCompanySlice';
import { formatDateEdit } from '../../constant/DateFormatEdit';
import { GetUpdateCompany } from '../../features/company/updateCompanySlice';
import ENGModalBody from '../../components/modal/ENGModalBody';
import { GetDeleteCompany } from '../../features/company/deleteCompanySlice';
import { useForm } from 'react-hook-form';
import Search from '../../assets/images/search-line.svg';
import SearchBar from '../../components/searchbar/SearchBar';
import CompanyTable from './CompanyTable';

const required = 'This field is required';
// Error Component
const errorMessage = (error: any) => {
  return <div className='invalid-feedback'>{error}</div>;
};
const ManageComapny = () => {
  // Edit Modal Code
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);

  const dispatch = useAppDispatch();
  const SectorList = useAppSelector(selectSectorList);
  const allCompany: any = useAppSelector(selectAllCompany);
  const [companyCode, setCompanyCode] = useState<any>();
  const [companyName, setCompanyName] = useState('');
  const [domainName, setDomainName] = useState('');
  const [policySource, setPolicySource] = useState<any>();
  const [sectorId, setSetSectorId] = useState('');
  const [validFrom, setValidFrom] = useState('');
  const [validTill, setValidTill] = useState('');
  const [recordId, setRecordId] = useState<Number>();
  const [isEdit, setIsEdit] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [searchData, setsearchData] = useState('');
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const [adfs, setAdfs] = useState(false);
  var searchParams = {
    type: 2,
    id: 0
  };
  useEffect(() => {
    async function fetchSectorData() {
      let sample = await dispatch(GetSectorList());
    }
    fetchSectorData();
    async function fetchCompanyData() {
      let sample = await dispatch(GetAllCompany(searchParams));
    }
    fetchCompanyData();
  }, []);

  const handleShow = () => {
    setModalShow(true);
    setIsEdit(false);
    clearForm();
    setModalTitle(
      ` Add ${adfs === false ? 'Non-SSO' : 'SSO'} Company Details `
    );
  };
  const clearForm = () => {
    setCompanyName('');
    setDomainName('');
    setPolicySource('');
    setSetSectorId('');
    setValidFrom('');
    setValidTill('');
  };
  const handleFormEdit = (item: any) => {
    setModalShow(true);
    setIsEdit(true);
    setModalTitle(' Edit Company Details ');
    // console.log(item)
    setCompanyName(item.company);
    setDomainName(item.emailidDomain);
    setPolicySource(item.policySource);
    setSetSectorId(item.sectorId);
    setValidFrom(formatDateEdit(item.validFrom));
    setValidTill(formatDateEdit(item.validTill));
    setCompanyCode(item.companyCode);
    setRecordId(item.id);
  };

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    //event.preventDefault();
    // console.log(policySource)
    var policyType;
    if (policySource === 'true') {
      policyType = true;
    } else {
      policyType = false;
    }
    if (isEdit === false) {
      var data = {
        company: companyName,
        sector: sectorId,
        activeDirectory: 'No',
        adfs: adfs,
        policySource: policyType,
        emailidDomain: domainName,
        sectorId: sectorId,
        validFrom: validFrom,
        validTill: validTill,
        companyCode: companyCode
      };
      // console.log(data)
      await dispatch(GetInsertCompany(data));
      await dispatch(GetAllCompany(searchParams));
      await setModalShow(false);
      await clearForm();
    } else {
      var editdata = {
        id: recordId,
        company: companyName,
        sector: sectorId,
        activeDirectory: 'No',
        policySource: policyType,
        adfs: adfs,
        emailidDomain: domainName,
        sectorId: sectorId,
        validFrom: validFrom,
        validTill: validTill,
        companyCode: companyCode
      };
      //console.log(editdata)
      await dispatch(GetUpdateCompany(editdata));
      await dispatch(GetAllCompany(searchParams));
      await setModalShow(false);
    }
  };
  //delete modal
  const [modalShow1, setModalShow1] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState<Number>();

  const handleClose1 = () => setModalShow1(false);
  const handleShow1 = (item: any) => {
    setModalShow1(true);
    setDeleteRecord(item.id);
  };

  const onDeleteRecord = async () => {
    var searchParams = {
      keyword: ''
    };
    await dispatch(GetDeleteCompany(deleteRecord));
    await dispatch(GetAllCompany(searchParams));
    setModalShow1(false);
  };

  /// pagination section start
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordPerPage;
  const currentRecordList = allCompany?.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const paginate = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };
  /// pagination section end

  //search section
  const [search, setSearch] = useState('');
  const [filteredCompany, setFilteredCompany] = useState([]);
  useEffect(() => {
    var filtredRecord = allCompany.filter((comapny: any) =>
      comapny.company.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredCompany(filtredRecord);
  }, [search, allCompany]);

  const handleNonSSOCompany = () => {
    var searchParams = {
      type: 2,
      id: 0
    };
    dispatch(GetAllCompany(searchParams));
    setAdfs(false);
  };
  const handleSSOCompany = () => {
    var searchParams = {
      type: 1,
      id: 0
    };
    dispatch(GetAllCompany(searchParams));
    setAdfs(true);
  };
  return (
    <>
      <Row>
        <Col lg={8}>
          <h4>Manage Company</h4>
        </Col>
        <Col lg={4}></Col>
      </Row>

      <div className='bgwhite b_shadow p_all mt-2 pt-2'>
        <EmptyRow />
        <div className='grid'>
          <div className='grid-container'>
            <Tab.Container defaultActiveKey='1'>
              <Nav>
                <Nav.Item style={styles.tabHeading}>
                  <Nav.Link
                    className='tabs1'
                    onClick={handleNonSSOCompany}
                    eventKey='1'
                  >
                    Non-SSO Company
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item style={styles.tabHeading}>
                  <Nav.Link
                    className='tabs1'
                    onClick={handleSSOCompany}
                    eventKey='2'
                  >
                    SSO Company
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey='1'>
                  <Row className='mb-3 mt-2'>
                    <Col sm={3}>
                      <InputGroup
                        className='border bg-white'
                        style={{ border: 'solid 1px #e4e4e4' }}
                      >
                        <Image
                          style={styles.image1}
                          className='d-inline border-0 my-auto mx-2'
                          src={Search}
                          fluid
                        />
                        <Form.Control
                          className='border-0 shadow-none ps-0'
                          type='text'
                          onChange={(e) => setSearch(e.target.value)}
                          name={searchData}
                          placeholder='Search Comapny'
                        />
                      </InputGroup>
                    </Col>
                    <Col sm={9}>
                      <a onClick={() => handleShow()}>
                        <button style={styles.button}> Add Company </button>
                      </a>
                    </Col>
                  </Row>
                  <CompanyTable
                    filteredCompany={filteredCompany}
                    handleFormEdit={handleFormEdit}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey='2'>
                  <Row className='mb-3 mt-2'>
                    <Col sm={3}>
                      <InputGroup
                        className='border bg-white'
                        style={{ border: 'solid 1px #e4e4e4' }}
                      >
                        <Image
                          style={styles.image1}
                          className='d-inline border-0 my-auto mx-2'
                          src={Search}
                          fluid
                        />
                        <Form.Control
                          className='border-0 shadow-none ps-0'
                          type='text'
                          onChange={(e) => setSearch(e.target.value)}
                          name={searchData}
                          placeholder='Search Comapny'
                        />
                      </InputGroup>
                    </Col>
                    <Col sm={9}>
                      <a onClick={() => handleShow()}>
                        <button style={styles.button}> Add Company </button>
                      </a>
                    </Col>
                  </Row>
                  <CompanyTable
                    filteredCompany={filteredCompany}
                    handleFormEdit={handleFormEdit}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
        {/* <Pagination
        paginate={paginate}
        recordPerPage={recordPerPage}
        totalRecords={allCompany?.length}
      /> */}
      </div>
      {/* edit role modal */}
      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <ENGModalHeader icon={icTitle} title={modalTitle} />
          <Modal.Body>
            <Row>
              <Col sm={12} xl={12} md={12}>
                <div className='floating-label-group'>
                  <input
                    type='text'
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setCompanyName(ev.target.value)
                    }
                    name='companyName'
                    ref={register({ required: true })}
                    defaultValue={companyName}
                    className='textstyle'
                  />
                  <label className='floating-label'>
                    Company Name <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.companyName &&
                  errors.companyName.type === 'required' &&
                  errorMessage(required)}
              </Col>
              <Col sm={12} xl={12} md={12} className='mt-4'>
                <div className='floating-label-group'>
                  <input
                    type='text'
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setDomainName(ev.target.value)
                    }
                    name='domainName'
                    ref={register({ required: true })}
                    defaultValue={domainName}
                    className='textstyle'
                  />
                  <label className='floating-label'>
                    Domain Name <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.domainName &&
                  errors.domainName.type === 'required' &&
                  errorMessage(required)}
                <label style={styles.link}>
                  Domain name means mail address extension e.g. if your id is
                  xyz@mahindralifspaces.com then please enter domain name as
                  mahindralifespaces.com and if having multiple domain then use
                  , (eg. mahindra.com, mahindralifspaces.com)
                </label>
              </Col>
              {adfs === true ? (
                <Col sm={12} xl={12} md={12} className='mt-4'>
                  <div className='floating-label-group'>
                    <input
                      type='text'
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>
                      ): void => setCompanyCode(ev.target.value)}
                      name='companyCode'
                      ref={register({ required: true })}
                      defaultValue={companyCode}
                      className='textstyle'
                    />
                    <label className='floating-label'>
                      Company Code <span style={styles.star}> * </span>
                    </label>
                  </div>
                  {errors.companyCode &&
                    errors.companyCode.type === 'required' &&
                    errorMessage(required)}
                  <label style={styles.link}>
                    Domain name means mail address extension e.g. if your id is
                    xyz@mahindralifspaces.com then please enter domain name as
                    mahindralifespaces.com and if having multiple domain then
                    use , (eg. mahindra.com, mahindralifspaces.com)
                  </label>
                </Col>
              ) : null}
            </Row>

            <Row className='mt-4'>
              <Col sm={12} xl={4} md={4}>
                <div className='floating-label-group'>
                  <select
                    onChange={(
                      ev: React.ChangeEvent<HTMLSelectElement>
                    ): void => setPolicySource(ev.target.value)}
                    defaultValue={policySource}
                    ref={register({ required: true })}
                    name='policySource'
                    className='textstyle'
                  >
                    <option value=''>Select</option>
                    <option value='false'>Rise 2.0</option>
                    <option value='true'>E&G</option>
                  </select>
                  <label className='floating-label'>
                    Select Policy Source <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.policySource &&
                  errors.policySource.type === 'required' &&
                  errorMessage(required)}
              </Col>
              {/* <Col sm={12} xl={6} md={6}>
                  <div className="floating-label-group">
                      <select  onChange={(
                        ev: React.ChangeEvent<HTMLSelectElement>
                      ): void => setSetSectorId(ev.target.value)} name="sector"
                      ref={register({ required: true })}
                      className="textstyle" defaultValue={sectorId}>
                          <option value="">Select</option>
                          {SectorList?.map((item:any)=>{
                            return(
                              <option key={item.id} value={item.sectorId}>{item.name}</option>
                            )
                          })}
                          
                        </select>
                        <label className="floating-label">
                        Select Sectors{" "}
                                        <span style={styles.star}> * </span>
                                      </label>
                      </div>
                      {errors.sector &&
                                        errors.sector.type === "required" &&
                                        errorMessage(required)}
                  </Col> */}
              {/* </Row>
                 
                  <Row className="mt-4"> */}
              <Col sm={12} xl={4} md={4}>
                <div className='floating-label-group'>
                  <input
                    type='date'
                    id='birthday'
                    name='ValidFrom'
                    className='textstyle form-control'
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setValidFrom(ev.target.value)
                    }
                    ref={register({ required: true })}
                    defaultValue={validFrom}
                  />
                  <label className='floating-label'>
                    Valid From <span style={styles.star}> * </span>
                  </label>
                  {errors.ValidFrom &&
                    errors.ValidFrom.type === 'required' &&
                    errorMessage(required)}
                </div>
                {/* {validFrom} */}
              </Col>
              <Col sm={12} xl={4} md={4}>
                <div className='floating-label-group'>
                  <input
                    type='date'
                    id='birthday'
                    name='validTill'
                    onChange={(ev: React.ChangeEvent<HTMLInputElement>): void =>
                      setValidTill(ev.target.value)
                    }
                    defaultValue={validTill}
                    ref={register({ required: true })}
                    className='textstyle form-control'
                  />
                  <label className='floating-label'>
                    Valid Till <span style={styles.star}> * </span>
                  </label>
                </div>
                {errors.validTill &&
                  errors.validTill.type === 'required' &&
                  errorMessage(required)}
              </Col>
            </Row>

            <Button
              style={styles.button}
              variant='primary'
              type='submit'
              className='mt-3 mb-3'
            >
              Submit
            </Button>
          </Modal.Body>
        </form>
      </Modal>
      <Modal
        show={modalShow1}
        onHide={handleClose1}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <ENGModalHeader icon={ModalDelete} title=' Delete Record ' />
        <ENGModalBody
          contents={
            <>
              <Row style={styles.divWhite}>
                <Col lg={12}>
                  <p style={styles.delcontent}>
                    Are you sure you want delete this record?
                  </p>
                </Col>
              </Row>
            </>
          }
        />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <Row style={styles.divGrey}>
          <Col sm={9}></Col>
          <Col sm={3}>
            <button type='button' onClick={handleClose1} style={styles.button1}>
              {' '}
              CANCEL{' '}
            </button>
            <button
              type='button'
              onClick={onDeleteRecord}
              style={styles.button}
            >
              {' '}
              DELETE{' '}
            </button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

const styles: any = {
  DivGrey: {
    backgroundColor: '#fcfbfb',
    border: '1px solid #eee'
  },

  bottom: {
    marginBottom: '23%'
  },
  link: {
    color: '#e31837',
    float: 'left',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  text1: {
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: 'normal',
    border: 'solid 1px #e4e4e4',
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    color: '#6d6e71',
    textAlign: 'left'
  },
  button: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff',
    float: 'right'
  },
  divWhite: {
    backgroundColor: '#ffffff',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px'
  },

  button1: {
    padding: '13px 15px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#ffffff',
    border: '1px solid #e31837',
    letterSpacing: 'normal',
    color: '#e31837'
  },
  star: {
    color: '#e31837'
  },
  divGrey: {
    backgroundColor: 'rgb(250, 249, 249)',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '20px',
    borderTop: '1px solid #eee;'
  },
  delcontent: {
    fontSize: '16px',
    color: '#242424'
  },
  checkmargin: {
    marginLeft: '15px'
  },

  imp: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '0px'
  },
  line: {
    margin: '23px 0px',
    backgroundColor: '#d8d8d8',
    height: '1.5px',
    padding: '0px'
  },

  content: {
    marginTop: '20px'
  },

  button2: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff',
    float: 'right'
  },

  Checkbox: {
    marginTop: '7px'
  },

  user: { width: '40px' }
};

export default ManageComapny;
